import React, { useMemo } from 'react';
import LoaderGIF from './images/Smart4Loader.gif';

export default function Loader({ style, imageStyle }) {
  const usedStyle = useMemo(() => {
    if (style) return style;
    return {
      position: 'sticky',
      height: 'calc(100vh - 60px)',
      width: '100vw',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    };
  }, [style]);

  return (
    <div style={usedStyle}>
      <img
        src={LoaderGIF}
        alt={LoaderGIF}
        style={imageStyle || { width: '30vw' }}
      />
    </div>
  );
}
